import React from 'react';
import { Star } from 'lucide-react';
import './Vision.css';

const Vision = () => {
  return (
    <section id="vision" className="vision-section">
      <div className="container">
        <div className="vision-content">
          <h2>
            <Star className="inline-icon" size={32} />
            {' '}Notre Vision / Our Vision / Unsere Vision{' '}
            <Star className="inline-icon" size={32} />
          </h2>
          <p className="vision-main">
            RÉVÉLER JÉSUS CHRIST AU MONDE<br />
            REVEAL JESUS CHRIST TO THE WORLD<br />
            JESUS CHRISTUS DER WELT OFFENBAREN
          </p>

          <div className="vision-verse">
            <p className="verse-text">
              "Mais, lorsqu'il plut à celui qui m'avait mis à part dès le sein de ma mère,
              et qui m'a appelé par sa grâce, de révéler en moi son Fils,
              afin que je l'annonçasse parmi les païens..."
            </p>
            <cite className="verse-cite">
              Galates 1:15 / Galatians 1:15 / Galater 1:15
            </cite>
          </div>

          <div className="foundation-verse">
            <p className="foundation-title">
              Notre Fondement / Our Foundation / Unsere Grundlage
            </p>
            <p className="foundation-text">
              "C'est l'esprit qui vivifie; la chair ne sert de rien.
              Les paroles que je vous ai dites sont esprit et vie."
            </p>
            <cite className="foundation-cite">
              Jean 6:63 / John 6:63 / Johannes 6:63
            </cite>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
